module.exports = __webpack_public_path__ + "static/img/2.1b225486.jpg";